import type { ShipperUserContext } from '@fv/models'

export const isCarrierAccount = ({
  accountRoles,
}: Pick<ShipperUserContext, 'accountRoles'>) =>
  accountRoles.includes('provisioner')

export const isCarrierAccountUser = (user: ShipperUserContext) =>
  isCarrierAccount(user)
